import React from 'react';

const strokeProps = {
    stroke: 'currentColor',
    strokeWidth: 1.7,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    fill: 'none',
};

export const CapTableIcon = () => (
    <svg width="17" height="17" viewBox="0 0 24 24" {...strokeProps}>
        <rect x="3" y="4" width="18" height="16" rx="2" />
        <path d="M3 10h18M9 10v10" />
    </svg>
);

export const HoldersIcon = () => (
    <svg width="17" height="17" viewBox="0 0 24 24" {...strokeProps}>
        <circle cx="9" cy="8" r="3.2" />
        <path d="M3.5 20c0-3.3 2.5-6 5.5-6s5.5 2.7 5.5 6" />
        <circle cx="17.5" cy="9" r="2.4" />
        <path d="M15.7 14.2c2.4.4 4.3 2.6 4.3 5.3" />
    </svg>
);

export const FundraiseIcon = () => (
    <svg width="17" height="17" viewBox="0 0 24 24" {...strokeProps}>
        <path d="M4 19V9M11 19V4M18 19v-6" />
        <path d="M3 19h18" />
    </svg>
);

export const TransfersIcon = () => (
    <svg width="17" height="17" viewBox="0 0 24 24" {...strokeProps}>
        <path d="M4 8h13l-3.5-3.5M20 16H7l3.5 3.5" />
    </svg>
);

export const ListingIcon = () => (
    <svg width="17" height="17" viewBox="0 0 24 24" {...strokeProps}>
        <path d="M5 4h14v16H5z" />
        <path d="M8.5 9h7M8.5 13h7M8.5 17h4" />
    </svg>
);

export const TradeIcon = () => (
    <svg width="17" height="17" viewBox="0 0 24 24" {...strokeProps}>
        <path d="M4 19V5" />
        <path d="M4 14l4-5 3 3 6-7" />
        <path d="M13 5h4v4" />
    </svg>
);
